<!--
  Navbar global do sistema, responsável pela navegação principal, troca de idioma, login, menus de usuário e modais de comunidades/convites.
-->
<template>
  <nav
    :class="['navbar navbar-expand-lg px-1 navbar-background', { 'border-bottom border-1 border-dark': hasBorder = true }]
    "
    role="navigation"
    aria-label="Barra de navegação principal"
  >
    <div class="container justify-content-between">
      <!-- Logo do sistema, retorna para a home -->
      <router-link to="" @click.prevent="handleLogoClick">
        <img :src="logoSrc" alt="logo do aquarela" width="130" class="navbar-logo">
      </router-link>
      <!-- Botão de menu responsivo -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapsibleNavbar"
        aria-controls="collapsibleNavbar"
        aria-expanded="false"
        aria-label="Alternar menu de navegação"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <!-- Itens da navbar principal -->
      <div class="collapse navbar-collapse justify-content-end" id="collapsibleNavbar" aria-label="Abrir menu de navegação">
        <ul class="navbar-nav align-items-center d-flex">
          <!-- Links institucionais -->
          <li class="nav-item">
            <router-link class="nav-link font-navbar" to="/sobrenos" @click="closeMainNavbar">{{ $t('navbar.sobreNos') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link font-navbar" to="/ajuda" @click="closeMainNavbar">{{ $t('navbar.faleConosco') }}</router-link>
          </li>
          <!-- <li class="nav-item">
            <router-link class="nav-link font-navbar" to="/tutorial" @click="closeMainNavbar">{{ $t('navbar.tutorial') }}</router-link>
          </li> -->
          <!-- Dropdown de idiomas -->
          <li class="nav-item dropdown me-2">
            <button class="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img :src="currentFlag.src" :alt="currentFlag.alt" width="35px">
            </button>
            <ul class="dropdown-menu mb-3">
              <li v-for="flag in flags.filter(f => f.src !== currentFlag.src)" :key="flag.alt">
                <div class="dropdown-item" @click="changeFlag(flag)">
                  <img :src="flag.src" :alt="flag.alt" width="35px" class="me-2">
                  <span>{{ flag.lang }}</span>
                </div>
              </li>
            </ul>
          </li>
          <!-- Botão de login ou ações rápidas para usuário logado -->
          <li>
            <!-- Exibe botão de login se não estiver logado -->
            <router-link to="/login" v-if="this.userStore.email === ''" @click="tab_active = null; closeMainNavbar()">
              <button class="btn botao-navbar">{{ $t('navbar.entrar') }}</button>
            </router-link>
            <!-- Quando estiver logado, mostra SEMPRE Novo REA + Nova comunidade -->
            <div v-else class="d-flex flex-wrap gap-2">
              <button
                class="btn botao-navbar"
                @click="handleNovoREA(); closeMainNavbar()"
              >
                {{ $t('navbar.novoREA') }}
              </button>

              <router-link
                to="/novacomunidade"
                @click="closeMainNavbar()"
              >
                <button class="btn botao-navbar">
                  {{ $t('navbar.novaComunidade') }}
                </button>
              </router-link>
            </div>
          </li>
          <!-- Dropdown do usuário logado -->
          <li class="nav-item dropdown" v-if="userStore.email != ''">
            <button class="nav-link dropdown-toggle d-flex align-items-center" type="button" data-bs-toggle="dropdown">
              <img
                :src="fotoPerfilUsuario"
                alt="Foto de perfil"
                class="rounded-circle navbar-profile-img"
                @error="usarImagemPadraoNavbar"
              >
            </button>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              <li>
                <router-link class="dropdown-item" :to="`/colaborador/${userStore.id}?tab=meus`" @click="closeMainNavbar">
                  {{ $t('navbar.perfil') }}
                </router-link>
              </li>
              <li>
                <router-link class="dropdown-item" :to="`/colaborador/${userStore.id}?tab=meus`" @click="closeMainNavbar">
                  {{ $t('navbar.meusREA') }}
                </router-link>
              </li>
              <!-- Acesso rápido às comunidades do usuário -->
              <li class="dropdown-item" style="cursor:pointer;" @click="showModalMinhasComunidades = true; fetchMinhasComunidades();">
                {{ $t('navbar.minhasComunidades') }}
              </li>
              <!-- Convites pendentes -->
              <li class="dropdown-item d-flex justify-content-between align-items-center" style="cursor:pointer;" @click="showModalConvites = true">
                <span>{{ $t('navbar.convites') }}</span>
                <span v-if="convites.length > 0" class="badge bg-danger rounded-pill ms-2">{{ convites.length }}</span>
              </li>
              <li><hr class="dropdown-divider"></li>
              <!-- Sair do sistema -->
              <li class="dropdown-item text-danger" @click="sair()">
                {{ $t('navbar.sair') }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!-- Modal: Minhas Comunidades -->
    <w-dialog v-model="showModalMinhasComunidades" :title="$t('navbar.minhasComunidades')" :width="900" persistent>
      <div v-if="minhasComunidades.length === 0" class="text-center">
        <p>{{ $t('navbar.nenhumaComunidadeCriada') }}</p>
      </div>
      <div v-else class="modal-body-scroll">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>{{ $t('comunidade.nome') }}</th>
              <th>{{ $t('comunidade.status') }}</th>
              <th>{{ $t('navbar.membros') }}</th>
              <th>{{ $t('comunidade.criacao') }}</th>
              <th>{{ $t('comunidade.acoes') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="comunidade in minhasComunidades" :key="comunidade.id">
              <td>
                <router-link :to="`/comunidade/${comunidade.id}`" class="text-decoration-none">
                  <span @click="showModalMinhasComunidades = false; closeMainNavbar();">{{ comunidade.nome }}</span>
                </router-link>
              </td>
              <td>
                <span :class="comunidade.ativo ? 'badge bg-success' : 'badge bg-danger'">
                  {{ comunidade.ativo ? $t('comunidade.ativa') : $t('comunidade.inativa') }}
                </span>
              </td>
              <td>{{ comunidade.quantidadeMembros }}</td>
              <td>{{ formatarData(comunidade.criacao) }}</td>
              <td>
                <!-- Botão para ativar/desativar comunidade (apenas para o dono) -->
                <button
                  v-if="isOwnerOfCommunity(comunidade)"
                  :class="comunidade.ativo ? 'btn btn-warning btn-sm' : 'btn btn-success btn-sm'"
                  @click="toggleCommunityStatus(comunidade)"
                >
                  {{ comunidade.ativo ? $t('comunidade.desativar') : $t('comunidade.reativar') }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #actions>
        <button class="btn btn-secondary" @click="showModalMinhasComunidades = false">{{ $t('navbar.fechar') }}</button>
      </template>
    </w-dialog>
    <!-- Modal: Convites -->
    <w-dialog v-model="showModalConvites" :title="$t('navbar.convites')" :width="900" persistent>
      <div v-if="loadingConvites" class="text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">{{ $t('navbar.carregando') }}</span>
        </div>
        <p class="mt-2">{{ $t('navbar.carregandoConvites') }}</p>
      </div>
      <div v-else-if="convites.length === 0" class="text-center">
        <i class="fas fa-envelope-open fa-3x text-muted mb-3"></i>
        <p>{{ $t('navbar.nenhumConvitePendente') }}</p>
      </div>
      <div v-else class="modal-body-scroll">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>{{ $t('navbar.comunidades') }}</th>
              <th>{{ $t('profile.modalConvite.convidante') }}</th>
              <th class="text-center">{{ $t('comunidade.acoes') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="convite in convites" :key="convite.links.find(l => l.rel === 'resourceURI').href">
              <td>
                <h6 class="mb-0">{{ convite.nomeComunidade }}</h6>
              </td>
              <td>
                <span>{{ convite.nomeConvidante }}</span>
                <br>
                <small class="text-muted">{{ formatarData(convite.data) }}</small>
              </td>
              <td class="text-center">
                <!-- Botões para aceitar ou recusar convite -->
                <button
                  class="btn btn-success btn-sm me-2"
                  @click="aceitarConvite(convite)"
                  :disabled="loadingAction"
                >
                  <i class="fas fa-check me-1"></i>
                  {{ $t('comunidade.modalPedidos.aceitar') }}
                </button>
                <button
                  class="btn btn-danger btn-sm"
                  @click="recusarConvite(convite)"
                  :disabled="loadingAction"
                >
                  <i class="fas fa-times me-1"></i>
                  {{ $t('comunidade.modalPedidos.recusar') }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #actions>
        <button class="btn botao-padrao me-2" @click="checkConvitesSilently(true)">
          <i class="fas fa-sync-alt me-1"></i> {{ $t('navbar.atualizarConvites') }}
        </button>
        <button class="btn btn-secondary" @click="showModalConvites = false">{{ $t('navbar.fechar') }}</button>
      </template>
    </w-dialog>
  </nav>
  <!-- Navbar secundária para navegação entre REA, Comunidades e Usuários -->
  <nav
    :class="['navbar-secondary', { 'border-bottom border-1 border-dark': hasBorder = false }]
    "
    role="navigation"
    aria-label="Barra de navegação secundária"
    v-if="['/', '/pesquisa'].includes($route.path)"
  >
    <div class="container">
      <ul class="nav justify-content-center flex-nowrap w-100">
        <!-- Abas de navegação secundária -->
        <li class="nav-item flex-fill">
          <router-link
            :to="{ path: '/pesquisa', query: { tipo: 'rea' } }"
            :class="['nav-link', { 'active': tab_active === 'REA' }]
            "
            @click="closeMainNavbar()"
            style="justify-content: center;"
          >
            <i class="fas fa-book"></i>
            <span class="ms-1">{{ $t('navbar.rea') }}</span>
          </router-link>
        </li>
        <li class="nav-item flex-fill">
          <router-link
            :to="{ path: '/pesquisa', query: { tipo: 'comunidade' } }"
            :class="['nav-link', { 'active': tab_active === 'Comunidades' }]
            "
            @click="closeMainNavbar()"
            style="justify-content: center;"
          >
            <i class="fas fa-users"></i>
            <span class="ms-1">{{ $t('navbar.comunidades') }}</span>
          </router-link>
        </li>
        <li class="nav-item flex-fill">
          <router-link
            :to="{ path: '/pesquisa', query: { tipo: 'user' } }"
            :class="['nav-link', { 'active': tab_active === 'Usuarios' }]
            "
            @click="closeMainNavbar()"
            style="justify-content: center;"
          >
            <i class="fas fa-user"></i>
            <span class="ms-1">{{ $t('navbar.usuarios') }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
  <!-- Modais globais para mensagens, confirmação e carregamento -->
  <ModalMessage ref="modalMessage" :title="title" :message="message" />
  <ModalConfirm ref="modalConfirm" :title="$t('navbar.sair')" :message="$t('navbar.msgSaida')" @confirmed="onConfirmCancel" :redirectTo="'/'" />
  <ModalConfirm
    ref="modalConfirmCommunity"
    :title="modalConfirmCommunityTitle"
    :message="modalConfirmCommunityMessage"
    @confirmed="modalConfirmCommunityCallback"
    :redirectTo="`/colaborador/${userStore.id}`"
  />
  <ModalLoading v-model="progress.show" :text="$t('modalCarregamento')" />
</template>

<script>
// Importações de dependências externas e componentes locais
import axios from "axios";
import { useUserStore } from '@/utils/stores/userStore';
import { useSearchStore } from '@/utils/stores/searchStore';
import { useDraftStore } from '@/utils/stores/draftStore';
import { formatarData } from '@/utils/helpers';
import { fotoPerfilEvent } from '@/utils/eventBus'
import { notifyConviteAceito } from '@/utils/eventBus'
import { watch } from 'vue'
import ModalMessage from './Modal/ModalMessage.vue';
import ModalConfirm from './Modal/ModalConfirm.vue';
import ModalLoading from './Modal/ModalLoading.vue';
import brasilFlag from "../assets/img/brasil-flag.jpg";
import americanFlag from "../assets/img/american-flag.png";
import spainFlag from "../assets/img/spain-flag.png";

export default {
  name: 'Navbar',

  // Registro dos componentes utilizados
  components: {
    ModalMessage,
    ModalConfirm,
    ModalLoading
  },

  // Setup para stores Pinia e inicialização do usuário
  setup() {
    const userStore = useUserStore();
    const searchStore = useSearchStore();
    const draftStore = useDraftStore();
    userStore.initialize();
    return { userStore, searchStore, draftStore };
  },

  // Estado reativo do componente
  data() {
    return {
      currentFlag: { src: brasilFlag, alt: "Bandeira do Brasil" },
      flags: [
        { src: brasilFlag, alt: "Bandeira do Brasil", lang: "pt-BR" },
        { src: americanFlag, alt: "Bandeira dos EUA", lang: "en-US" },
        { src: spainFlag, alt: "Bandeira da Espanha", lang: "es-ES" }
      ],
      file: null,
      title: '',
      message: '',
      // tab_active: 'REA',
      tab_active: null,
      comunidade: null,
      progress: { show: false },
      showModalMinhasComunidades: false,
      minhasComunidades: [],
      showModalConvites: false,
      convites: [],
      loadingConvites: false,
      loadingAction: false,
      convitesCheckInterval: null,
      userComunidades: [],
      fotoPerfilUsuario: new URL('@/assets/img/user-icon.png', import.meta.url).href,
      modalConfirmCommunityTitle: '',
      modalConfirmCommunityMessage: '',
      modalConfirmCommunityCallback: null,
    };
  },

  // Computed para verificar se usuário é membro da comunidade atual
  computed: {
    isCurrentMember() {
      return this.userComunidades.some(c => c.id === this.comunidade?.id);
    },

    logoSrc() {
      // Se usuário estiver em comunidade
      if (this.userStore.communityId) {
        if (this.$i18n.locale === 'pt') {
          return new URL('@/assets/img/aquarela-comunidades.png', import.meta.url).href
        } else {
          return new URL('@/assets/img/aquarela-communities.png', import.meta.url).href
        }
      }

      // Logo padrão
      return new URL('@/assets/img/aquarela.png', import.meta.url).href
    }
  },

  // Observa mudanças no e-mail do usuário para atualizar convites e foto de perfil
  watch: {
    'userStore.email': {
      handler(newEmail) {
        if (newEmail) {
          this.startConvitesCheck();
          this.carregarFotoPerfilUsuario();
        } else {
          this.stopConvitesCheck();
          this.fotoPerfilUsuario = new URL('@/assets/img/user-icon.png', import.meta.url).href;
        }
      },
      immediate: true
    },

    $route: {
      handler(to) {
        if (to.path === '/')
          this.tab_active = null;
        else
        if (to.path === '/pesquisa' && !this.tab_active)
          this.tab_active = 'REA';
      },
      immediate: true
    },

    '$route.query.tipo': {
      handler(newTipo) {
        if (!newTipo) return
        if (newTipo === 'rea') {
          this.tab_active = 'REA'
          this.searchStore.tipoBusca = 'rea'
        } else if (newTipo === 'comunidade') {
          this.tab_active = 'Comunidades'
          this.searchStore.tipoBusca = 'comunidade'
        } else if (newTipo === 'user') {
          this.tab_active = 'Usuarios'
          this.searchStore.tipoBusca = 'user'
        }
        else this.tab_active = null;
      },
      immediate: true
    }
  },

  mounted() {
    watch(fotoPerfilEvent, (val) => {
      if (val.updated) {
        this.carregarFotoPerfilUsuario()
        fotoPerfilEvent.value.updated = false // reseta o flag
      }
    }, { immediate: true })
  },

  // Limpa intervalos e blobs ao desmontar o componente
  beforeUnmount() {
    this.stopConvitesCheck();
    if (this.fotoPerfilUsuario && this.fotoPerfilUsuario.startsWith('blob:')) {
      URL.revokeObjectURL(this.fotoPerfilUsuario);
    }
  },

  methods: {
    // Busca a foto de perfil do usuário logado
    async carregarFotoPerfilUsuario() {
      if (!this.userStore.isLogged || !this.userStore.id) {
        this.fotoPerfilUsuario = new URL('@/assets/img/user-icon.png', import.meta.url).href;
        return;
      }
      try {
        const response = await axios.get(
          `${this.$dominio}/api/colaboradores/${this.userStore.id}/foto`,
          {
            headers: {
              'Authorization': 'Bearer ' + this.userStore.token
            },
            responseType: 'blob'
          }
        );
        if (response.data && response.data.size > 0) {
          if (this.fotoPerfilUsuario && this.fotoPerfilUsuario.startsWith('blob:')) {
            URL.revokeObjectURL(this.fotoPerfilUsuario);
          }
          this.fotoPerfilUsuario = URL.createObjectURL(response.data);
        } else {
          this.usarImagemPadraoNavbar();
        }
      } catch (error) {
        this.usarImagemPadraoNavbar();
      }
    },

    // Usa imagem padrão caso não haja foto de perfil
    usarImagemPadraoNavbar() {
      if (this.fotoPerfilUsuario && this.fotoPerfilUsuario.startsWith('blob:')) {
        URL.revokeObjectURL(this.fotoPerfilUsuario);
      }
      this.fotoPerfilUsuario = new URL('@/assets/img/user-icon.png', import.meta.url).href;
    },

    // Formata datas para exibição
    formatarData,

    // Verifica se o usuário logado é dono da comunidade
    isOwnerOfCommunity(comunidade) {
      const colaboradorLink = comunidade.links.find(link => link.rel === 'colaborador');
      if (colaboradorLink) {
        const ownerId = colaboradorLink.href.split('/').pop();
        return this.userStore.id == ownerId;
      }
      return false;
    },

    // Busca comunidades do usuário para o modal "Minhas Comunidades"
    async fetchMinhasComunidades() {
      const response = await axios.get(`${this.$dominio}/api/colaboradores/${this.userStore.id}/associacoes`);
      this.minhasComunidades = response.data.comunidades || [];
    },

    // Redireciona para criação de novo REA, considerando contexto de comunidade
    handleNovoREA() {
      const currentPath = this.$route.path;
      const comunidadeMatch = currentPath.match(/^\/comunidade\/(\d+)$/);
      if (comunidadeMatch) {
        const comunidadeId = comunidadeMatch[1];
        this.draftStore.data.comunidade = comunidadeId;
      } else {
        this.draftStore.data.comunidade = '';
      }
      this.$router.push('/novorea');
      this.closeMainNavbar();
    },

    // Troca o idioma do sistema
    changeFlag(flag) {
      this.currentFlag = flag;
      if (flag.lang === 'pt-BR') {
        this.$i18n.locale = 'pt';
      } else if (flag.lang === 'en-US') {
        this.$i18n.locale = 'en';
      } else if (flag.lang === 'es-ES') {
        this.$i18n.locale = 'es';
      }
      this.closeMainNavbar();
    },

    // Ativa/desativa comunidade (apenas para o dono)
    async toggleCommunityStatus(comunidade) {
      const messageKey = comunidade.ativo
        ? 'comunidade.confirmacoes.desativarComunidade'
        : 'comunidade.confirmacoes.reativarComunidade';
      this.modalConfirmCommunityTitle = this.$t('comunidade.modalCapa.confirmar');
      this.modalConfirmCommunityMessage = `${this.$t(messageKey)} "${comunidade.nome}"?`;
      this.modalConfirmCommunityCallback = async () => {
        this.progress.show = true;
        try {
          const endpoint = comunidade.ativo ? '/desativar' : '/reativar';
          await axios.patch(
            `${this.$dominio}/api/comunidades/${comunidade.id}${endpoint}`,
            {},
            {
              headers: {
                'Authorization': 'Bearer ' + this.userStore.token
              }
            }
          );
          comunidade.ativo = !comunidade.ativo;
        } catch (error) {
          // Tratar erro, se necessário
        } finally {
          this.progress.show = false;
        }
      };
      this.$nextTick(() => {
        this.$refs.modalConfirmCommunity.openModal();
      });
    },

    // Inicia processo de logout, exibindo modal de confirmação
    sair() {
      const hasDraft = Object.keys(localStorage).some(key => key.startsWith('draft'));
      if (hasDraft) {
        this.openMessageModal(
          this.$t('tinyEditor.aviso'),
          this.$t('navbar.rascunhoPendente')
        );
        return;
      }
      this.title = this.$t('navbar.sair');
      this.message = this.$t('navbar.msgSaida');
      this.$nextTick(() => {
        this.$refs.modalConfirm.openModal();
      });
    },

    // Confirmação do logout
    onConfirmCancel() {
      this.userStore.logout();
      this.searchStore.reset();

      this.handleLogoClick();
    },

    // Exibe modal de mensagem customizada
    openMessageModal(title, message) {
      this.title = title;
      this.message = message;
      this.$nextTick(() => {
        this.$refs.modalMessage.openModal();
      });
    },

    // Busca convites pendentes do usuário
    async checkConvitesSilently(showLoading = false) {
      if (!this.userStore.email || !this.userStore.id) return;
      if (showLoading) this.loadingConvites = true;
      try {
        const response = await axios.get(`${this.$dominio}/api/colaboradores/${this.userStore.id}/convites`, {
          headers: {
            'Authorization': 'Bearer ' + this.userStore.token,
            'Content-Type': 'application/json'
          }
        });
        this.convites = response.data.tickets || [];
      } catch (error) {
      } finally {
        if (showLoading) this.loadingConvites = false;
      }
    },

    // Inicia verificação periódica de convites
    startConvitesCheck() {
      if (this.convitesCheckInterval) {
        clearInterval(this.convitesCheckInterval);
      }
      this.fetchUserAssociacoes();
      this.checkConvitesSilently();
      this.convitesCheckInterval = setInterval(() => {
        this.checkConvitesSilently(false);
      }, 300000);
    },

    // Para verificação periódica de convites
    stopConvitesCheck() {
      if (this.convitesCheckInterval) {
        clearInterval(this.convitesCheckInterval);
        this.convitesCheckInterval = null;
      }
      this.convites = [];
    },

    // Aceita convite de comunidade
    async aceitarConvite(convite) {
      this.loadingAction = true;
      try {
        const aceitarLink = convite.links.find(link => link.rel === 'aceitar');
        await axios.patch(
          aceitarLink.href,
          {},
          {
            headers: {
              'Authorization': 'Bearer ' + this.userStore.token,
              'Content-Type': 'application/json'
            }
          }
        );
        await this.fetchUserAssociacoes();
        const resourceURI = convite.links.find(l => l.rel === 'resourceURI').href;
        this.convites = this.convites.filter(c => c.links.find(l => l.rel === 'resourceURI').href !== resourceURI);

        // Notifica ComunidadeView sobre o convite aceito
        const comunidade = convite.links.find(l => l.rel === 'comunidade').href;
        const comunidadeId = comunidade.split('/').pop();
        notifyConviteAceito(comunidadeId);

        this.openMessageModal(
          this.$t('tinyEditor.aviso'),
          this.$t('comunidade.alertas.conviteAceitoSucesso')
        );
      } catch (error) {
        // Erro ao aceitar o convite
      } finally {
        this.loadingAction = false;
      }
    },

    // Recusa convite de comunidade
    async recusarConvite(convite) {
      this.loadingAction = true;
      try {
        const rejeitarLink = convite.links.find(link => link.rel === 'rejeitar');
        await axios.patch(
          rejeitarLink.href,
          {},
          {
            headers: {
              'Authorization': 'Bearer ' + this.userStore.token,
              'Content-Type': 'application/json'
            }
          }
        );
        const resourceURI = convite.links.find(l => l.rel === 'resourceURI').href;
        this.convites = this.convites.filter(c => c.links.find(l => l.rel === 'resourceURI').href !== resourceURI);
        this.openMessageModal(
          this.$t('tinyEditor.aviso'),
          this.$t('comunidade.alertas.pedidoRecusado')
        );
      } catch (error) {
        // Erro ao recusar o convite
      } finally {
        this.loadingAction = false;
      }
    },

    // Troca para aba REA na navbar secundária
    // switchToREATab() {
    //   this.tab_active = 'REA';
    //   this.searchStore.tipoBusca = 'rea';
    //   this.searchStore.currentPageREA = 1;
    //   this.searchStore.newSearch += 1;
    //   this.searchStore.triggerHeaderUpdate();
    // },

    // Troca para aba Comunidades na navbar secundária
    // switchToComunidadesTab() {
    //   this.tab_active = 'Comunidades';
    //   this.searchStore.tipoBusca = 'comunidade';
    //   this.searchStore.currentPageComunidades = 1;
    //   this.searchStore.newSearch += 1;
    //   this.searchStore.triggerHeaderUpdate();
    // },

    // Troca para aba Usuários na navbar secundária
    // switchToUsuariosTab() {
    //   this.tab_active = 'Usuarios';
    //   this.searchStore.tipoBusca = 'user';
    //   this.searchStore.currentPageUsuarios = 1;
    //   this.searchStore.newSearch += 1;
    //   this.searchStore.triggerHeaderUpdate();
    // },

    // Fecha o menu principal em dispositivos móveis
    closeMainNavbar() {
      const navbarCollapse = document.getElementById('collapsibleNavbar');
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        try {
          if (window.bootstrap && window.bootstrap.Collapse) {
            const bsCollapse = window.bootstrap.Collapse.getInstance(navbarCollapse) ||
              new window.bootstrap.Collapse(navbarCollapse, { toggle: false });
            bsCollapse.hide();
          } else {
            navbarCollapse.classList.remove('show');
            navbarCollapse.classList.add('collapsing');
            navbarCollapse.style.height = '0px';
            setTimeout(() => {
              navbarCollapse.classList.remove('collapsing');
              navbarCollapse.classList.add('collapse');
              navbarCollapse.style.height = '';
            }, 350);
          }
        } catch (error) {
          navbarCollapse.classList.remove('show');
        }
      }
    },

    // Busca associações do usuário (comunidades que participa)
    async fetchUserAssociacoes() {
      if (!this.userStore.id || !this.userStore.token) return;
      try {
        const response = await axios.get(`${this.$dominio}/api/colaboradores/${this.userStore.id}/associacoes`, {
          headers: {
            'Authorization': 'Bearer ' + this.userStore.token,
            'Content-Type': 'application/json'
          }
        });
        this.userComunidades = response.data.comunidades || [];
      } catch (error) {
        this.userComunidades = [];
      }
    },

    // Ao clicar no logo, volta para a homepage e fecha o menu
    handleLogoClick() {
      if (this.userStore.communityId) {
        this.$router.push(`/comunidade/${this.userStore.communityId}/inicio`);
      }
      else {
        this.closeMainNavbar();
        this.tab_active = null;
        this.searchStore.tipoBusca = null;
        this.$router.push('/')
      }
    },
  }
}
</script>

<style scoped>
.navbar-background {
  background-color: #FFFFE8; /* exemplo: azul mais escuro */
}

/* Estilos para a navbar principal e secundária, incluindo responsividade e acessibilidade visual */
.font-navbar {
  color: #333333;
  font-size: 18px;
}

.font-navbar:hover {
  color: #000;
}

.btn.botao-navbar {
  background-color: var(--sec-color);
  color: var(--main-color);
  font-size: 18px;
}

.btn.botao-navbar:hover {
  background-color: var(--blue-hover);
}

.navbar-secondary {
  background-color: var(--sec-color);
}

.navbar-secondary .nav {
  display: flex;
  padding: 0;
  margin: 0;
  list-style: none;
  width: 100%;
}

.navbar-secondary .nav-item {
  flex: 1;
}

.navbar-secondary .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  color: #FFFFE8;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.navbar-secondary .nav-link:hover {
  opacity: 0.7;
}

.navbar-secondary .nav-link i {
  font-size: 1rem;
}

.navbar-secondary .nav-link span {
  font-size: 0.95rem;
}

.active {
  background-color: #ffc000;
  color: #000 !important;
}

.navbar-logo {
  margin-top: -5px;
}

.navbar-profile-img {
  width: 32px;
  height: 32px;
  object-fit: cover;
}

.btn.botao-padrao:active {
  background-color: var(--sec-color) !important; /* mesma cor que já usa */
  color: var(--main-color) !important;
  box-shadow: none !important; /* opcional, remove contorno azul */
}

.modal-body-scroll {
  max-height: 60vh;   /* limita altura a 60% da viewport */
  overflow-y: auto;   /* ativa scroll vertical */
  padding-right: 10px; /* espaço pro scroll não sobrepor conteúdo */
}

@media (max-width: 992px) {
  .navbar-secondary .navbar-collapse {
    margin-top: 10px;
    background-color: var(--sec-color);
  }
  .navbar-secondary .nav-item {
    flex: none;
    width: 100%;
  }
  .navbar-secondary .nav-link {
    justify-content: flex-start;
    padding: 12px 20px;
    height: auto;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .navbar-secondary .nav-link:last-child {
    border-bottom: none;
  }
}

@media (max-width: 576px) {
  .navbar-secondary .nav-link {
    padding: 10px 15px;
    font-size: 0.9rem;
  }
  .navbar-secondary .nav-link i {
    font-size: 0.9rem;
  }
  .navbar-secondary .nav-link span {
    font-size: 0.85rem;
  }
}
@media (min-width: 992px) {
  .navbar-secondary .d-lg-flex {
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
}
</style>